import getScrollbarSize from '@mui/utils/getScrollbarSize';
export default getScrollbarSize;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/getScrollbarSize.js
// module id = 1919
// module chunks = 25